import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/dashboard'

// API bazen 200 dönüp içeriği bozuk/eksik gönderiyor (ör. package yok → UsageCard
// crash, completion_rate yok → %NaN). Yanıt geçerli sayılması için: nesne olmalı,
// package alt-nesnesi bulunmalı ve sayısal alanlar null veya sonlu sayı olmalı
// (undefined/NaN = bozuk). Geçersizse veriyi state'e yazmayıp (güvenli varsayılanlar
// korunur) error bayrağını set edip tek b-alert gösteriyoruz.
const numOrNull = v => v === null || (typeof v === 'number' && Number.isFinite(v))
const isValidDashboard = d => !!d
  && typeof d === 'object'
  && !!d.package && typeof d.package === 'object'
  && numOrNull(d.active_projects)
  && numOrNull(d.active_tasks)
  && numOrNull(d.completion_rate)
export default {
  namespaced: true,
  state: {
    loading: false,
    error: false,
    counters: [],
    package: {
      package_name: null,
      expiration: null,
      diskUsage: {
        usage: null,
        limit: null,
        percent: null,
        variant: null,
      },
      users: null,
    },
    active_projects: null,
    active_tasks: null,
    completion_rate: null,
  },
  getters: {
    loading(state) {
      return state.loading
    },
    error(state) {
      return state.error
    },
    counters(state) {
      return state.counters
    },
    package(state) {
      return state.package
    },
    active_projects(state) {
      return state.active_projects
    },
    active_tasks(state) {
      return state.active_tasks
    },
    completion_rate(state) {
      return state.completion_rate
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_ERROR(state, data) {
      state.error = data
    },
    SET_DASHBOARD(state, data) {
      state.counters = data.counters || []
      state.package = data.package || state.package
      state.active_projects = data.active_projects ?? null
      state.active_tasks = data.active_tasks ?? null
      state.completion_rate = data.completion_rate ?? null
    },
  },
  actions: {
    getDashboard({ commit }, params) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', false)
      return axiosIns
        .get(ROOT_URL, { params })
        .then(response => {
          if (!isValidDashboard(response.data)) {
            commit('SET_ERROR', true)
            commit('SET_LOADING', false)
            return
          }
          commit('SET_DASHBOARD', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('SET_LOADING', false)
          commit('SET_ERROR', true)
          console.error(error)
        })
    },
  },
}
